import CurrentRoleActionTypes from './CurrentRoleActionTypes';
import CurrentRoleDispatcher from './CurrentRoleDispatcher';

const Actions = {
  setCurrentUserRole(roleKey) {
    CurrentRoleDispatcher.dispatch({
      type: CurrentRoleActionTypes.SET_CURRENT_USER_ROLE,
      roleKey,
    });
  },

  findAndSetCurrentUserRole(criteria) {
    CurrentRoleDispatcher.dispatch({
      type: CurrentRoleActionTypes.FIND_AND_SET_CURRENT_USER_ROLE,
      criteria,
    });
  },

  deleteCurrentUserRole(roleKey) {
    CurrentRoleDispatcher.dispatch({
      type: CurrentRoleActionTypes.DELETE_CURRENT_USER_ROLE,
      roleKey,
    });
  },

  refreshCurrentUserRole() {
    CurrentRoleDispatcher.dispatch({
      type: CurrentRoleActionTypes.REFRESH,
    });
  },

  changeCurrentUserRole(role) {
    CurrentRoleDispatcher.dispatch({
      type: CurrentRoleActionTypes.CHANGE_CURRENT_USER_ROLE,
      role
    });
  },
};

export default Actions;


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/actions/CurrentRoleActions.js